import {
  COOPERATION_CURRENCY_OPTIONS,
} from "../lib/cooperationOffer";

/**
 * Property create/edit section: «Винагорода партнеру».
 * Prop-driven; expects cooperation_* fields on `values` and setField via onChange.
 */
function CooperationOfferFields({
  values,
  onChange,
  fieldErrors = {},
  idPrefix = "coop",
}) {
  const setField = (key, value) => onChange({ ...values, [key]: value });

  const enabled = Boolean(values.cooperation_enabled);
  const type = values.cooperation_type || "";

  const handleEnabledChange = (checked) => {
    if (!checked) {
      onChange({
        ...values,
        cooperation_enabled: false,
        cooperation_type: "",
        cooperation_value: "",
        cooperation_currency: values.cooperation_currency || "USD",
      });
      return;
    }
    setField("cooperation_enabled", true);
  };

  const handleTypeChange = (nextType) => {
    onChange({
      ...values,
      cooperation_type: nextType,
      // Clear value when switching modes to avoid percent/fixed mix.
      cooperation_value: "",
      cooperation_currency:
        nextType === "fixed"
          ? values.cooperation_currency || values.currency || "USD"
          : values.cooperation_currency || "USD",
    });
  };

  return (
    <fieldset className="ap-fieldset" data-section="cooperation-offer">
      <legend>Винагорода партнеру</legend>
      <p className="form-hint">
        Увімкніть, якщо готові співпрацювати з іншими ріелторами за винагороду.
      </p>

      <div className="ap-checkbox-row">
        <label className="check-card">
          <input
            type="checkbox"
            id={`${idPrefix}-enabled`}
            name="cooperation_enabled"
            checked={enabled}
            onChange={(e) => handleEnabledChange(e.target.checked)}
            aria-describedby={`${idPrefix}-enabled-hint`}
          />
          <span className="check-card__icon">
            <i className="fa-solid fa-handshake" aria-hidden="true" />
          </span>
          <span className="check-card__body">
            <strong>Відкрито до співпраці</strong>
            <small id={`${idPrefix}-enabled-hint`}>
              Інші ріелтори зможуть запропонувати свого клієнта
            </small>
          </span>
        </label>
      </div>
      {fieldErrors.cooperation_enabled ? (
        <small className="form-hint text-danger" role="alert">
          {fieldErrors.cooperation_enabled}
        </small>
      ) : null}

      {enabled ? (
        <div className="ap-row ap-row--3" style={{ marginTop: "0.75rem" }}>
          <div className="ap-field">
            <label htmlFor={`${idPrefix}-type`}>
              Тип винагороди <span className="req">*</span>
            </label>
            <select
              id={`${idPrefix}-type`}
              name="cooperation_type"
              className="form-select"
              value={type}
              onChange={(e) => handleTypeChange(e.target.value)}
              aria-invalid={fieldErrors.cooperation_type ? "true" : undefined}
            >
              <option value="">Оберіть тип</option>
              <option value="percent">Відсоток від ціни угоди</option>
              <option value="fixed">Фіксована сума</option>
            </select>
            {fieldErrors.cooperation_type ? (
              <small className="form-hint text-danger" role="alert">
                {fieldErrors.cooperation_type}
              </small>
            ) : null}
          </div>

          <div className="ap-field">
            <label htmlFor={`${idPrefix}-value`}>
              Значення <span className="req">*</span>
            </label>
            <input
              id={`${idPrefix}-value`}
              name="cooperation_value"
              type="number"
              className="form-control"
              min="0"
              step="0.01"
              placeholder={type === "percent" ? "напр. 5" : "напр. 2500"}
              value={values.cooperation_value ?? ""}
              onChange={(e) => setField("cooperation_value", e.target.value)}
              aria-invalid={fieldErrors.cooperation_value ? "true" : undefined}
            />
            <small className="form-hint">
              {type === "percent"
                ? "Відсоток від 0 до 100."
                : "Сума має бути більшою за 0."}
            </small>
            {fieldErrors.cooperation_value ? (
              <small className="form-hint text-danger" role="alert">
                {fieldErrors.cooperation_value}
              </small>
            ) : null}
          </div>

          {type === "fixed" ? (
            <div className="ap-field">
              <label htmlFor={`${idPrefix}-currency`}>
                Валюта <span className="req">*</span>
              </label>
              <select
                id={`${idPrefix}-currency`}
                name="cooperation_currency"
                className="form-select"
                value={values.cooperation_currency || "USD"}
                onChange={(e) => setField("cooperation_currency", e.target.value)}
                aria-invalid={
                  fieldErrors.cooperation_currency ? "true" : undefined
                }
              >
                {COOPERATION_CURRENCY_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
              {fieldErrors.cooperation_currency ? (
                <small className="form-hint text-danger" role="alert">
                  {fieldErrors.cooperation_currency}
                </small>
              ) : null}
            </div>
          ) : (
            <div className="ap-field" aria-hidden="true" />
          )}
        </div>
      ) : null}

      {enabled ? (
        <div className="ap-field" style={{ marginTop: "0.75rem" }}>
          <label htmlFor={`${idPrefix}-terms`}>Умови співпраці</label>
          <textarea
            id={`${idPrefix}-terms`}
            name="cooperation_terms"
            className="form-control"
            rows={3}
            value={values.cooperation_terms ?? ""}
            onChange={(e) => setField("cooperation_terms", e.target.value)}
            placeholder="Необов'язково"
            aria-invalid={fieldErrors.cooperation_terms ? "true" : undefined}
          />
          {fieldErrors.cooperation_terms ? (
            <small className="form-hint text-danger" role="alert">
              {fieldErrors.cooperation_terms}
            </small>
          ) : null}
        </div>
      ) : null}
    </fieldset>
  );
}

export default CooperationOfferFields;
